/**
 * Performs a *naive* validation of the ADF JSON string by parsing it and
 * checking that some of the required top-level properties are present.
 *
 * @remark
 * This fulfils all use cases where we accept system-generated ADF. Once we
 * start accepting user-generated ADF from consumers as part of WDF, we will
 * want to switch to a full-blown check.
 *
 * See https://bitbucket.org/atlassian/canvas/pull-requests/14863 for what a
 * more comprehensive check could look like.
 *
 * Note that `@atlaskit/adf-utils/validator` is NOT a suitable replacement as it
 * is designed to mutate an invalid doc into one that the editor can parse and
 * display with appropriate graceful degradations etc. (read [this
 * thread](https://atlassian.slack.com/archives/C06B9J0LWFM/p1723178971486959?thread_ts=1723164914.294479&cid=C06B9J0LWFM)
 * for more context).
 */
export const validateAdf = (value: string | object) => {
  try {
    const adf = typeof value === 'string' ? JSON.parse(value) : value;
    return !!(
      adf &&
      typeof adf === 'object' &&
      adf.version &&
      adf.type &&
      adf.content &&
      Array.isArray(adf.content)
    );
  } catch (e) {
    return false;
  }
};
